import { cloneObject } from "@utils/object";

/**
 * Returns new schema consisting from certain parts of a DTO,
 * preserving all values and required attributes.
 */
export const split = (schem, keys) => {
  if (!schem.properties || !keys) return schem;
  const schema = cloneObject(schem);
  if (schem.required) {
    schema.required = schem.required ? schem.required.filter(req => keys.includes(req)) : [];
  }
  for (const key in schema.properties) {
    if (!keys.includes(key)) delete schema.properties[key];
  }
  return schema;
};
